module.exports = __webpack_public_path__ + "img/5ec9dfc845af5da21c7d676eebbb10d.4b63f577.png";